/** "8:00 AM" */
export const formatTime = (date: Date, timeZone?: string): string =>
  new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', timeZone }).format(date);
